import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d21eb17e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-title-number-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "fas fa-check"
}

import { DxProgressBar } from "devextreme-vue/progress-bar";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tenant-switch-progress',
  props: {
  /**
   * The index of the item in the list.
   * @type {number}
   * @required
   */
  index: {
    type: Number,
    required: true,
  },

  /**
   * The title associated with the item.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    required: true,
  },

  /**
   * The number associated with the item, which could represent a quantity or identifier.
   * @type {number}
   * @required
   */
  number: {
    type: Number,
    required: true,
  },

  /**
   * The progress percentage for the item, represented as a number between 0 and 100.
   * @type {number}
   * @required
   */
  progress: {
    type: Number,
    required: true,
  },
  fontSize: {
    type: String,
    default: "12px",
  },
},
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "24230e63": (props.fontSize)
}))



const screeWidth = ref(screen.width);

const comparisonIndex = computed(() => {
  return props.number - 1;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([{
        pageNumberCompleted: __props.index > comparisonIndex.value,
        pageNumberReached: __props.index == comparisonIndex.value,
      }, "page-number"])
      }, [
        (__props.index <= comparisonIndex.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.number), 1))
          : _createCommentVNode("", true),
        (__props.index > comparisonIndex.value)
          ? (_openBlock(), _createElementBlock("i", _hoisted_3))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("span", null, _toDisplayString(__props.title), 1)
    ]),
    (__props.progress != -1 && screeWidth.value >= 768)
      ? (_openBlock(), _createBlock(_unref(DxProgressBar), {
          key: 0,
          class: "progress-bar",
          value: __props.progress,
          showStatus: false,
          width: "10%",
          max: 1
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})